<template>
  <div>
    <div v-if="showDefaultForm">
      <el-form :model="approve" size="small">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="审批意见">
              <el-input v-model="approve.comment" maxlength="200" show-word-limit type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="buttonGroup">
      <component :is="userSelectDlg" ref="userSelectDlg" :can-select-system-role="false"
        :can-select-project-role="false" :custom-com-params="customComParams" :show-selection="false" @userSelected="afterUserSelected" />
      <div class="approveButton">
        <el-button type="primary" size="small" @click="transfer">转交</el-button>
        <el-button type="success" size="small" @click="agree">同意</el-button>
        <el-button type="danger" size="small" @click="rejectNodeFlow">驳回</el-button>
      </div>
    </div>
    <div v-if="allowAddNode">
      <addApproveNode ref="addTempNode" :node-def="nodeDef" :flow-instance-node-id="flowInstanceNodeId"
        @added="handleTmpNodeChanged" @deleted="handleTmpNodeChanged" />
    </div>
  </div>
</template>
<script>
import personChoose from "@/CommonDP/pages/components/launchFlow/components/personChoose";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { uploadDataUrl, getToken } from "@/CommonDP/utils";
import { notBlank } from "@/CommonDP/utils/validate";
import { ApproveAction } from "@/CommonDP/enums/FlowConstants";
import { getUserSelectDlg } from "../flowFormRegister";
import addApproveNode from "./addApproveNode.vue";

const APPROVE = () => ({
  comment: "", // 审批意见
  flowInstanceNodeId: "",
  transferId: "",
  fileIds: [],
  name: ""
});
export default {
  components: { personChoose, addApproveNode },
  props: {
    enableUpload: {
      type: Boolean,
      default: false
    },
    // 要求返回 true/false 表示是否继续
    // 原型：bool fn() 或者 Promise fn(), 其中 Promise 的 resolve 要返回一个 bool
    beforeAgree: {
      type: Function,
      default: null
    },

    showDefaultForm: {
      type: Boolean,
      default: true
    },

    // 原型：Object fn(action, approve)
    // 其中 action 取三个值：agree, reject, transfer
    // 其中 approve 是现有的审批数据（非 null）
    queryApproveData: {
      type: Function,
      default: null
    },

    // 原型：int fn(action, approve) 或 Promise fn(), 其中 Promise 的 resolve 要返回一个 int
    // 其中 action 取三个值：agree, reject, transfer
    // 其中 approve 是现有的审批数据（非 null）
    // 返回 0 或空表示不验证，而由内部自己验证。1 表示验证通过，2表示不通过
    validateFn: {
      type: Function,
      default: null
    },
    // 自定义选人组件所需参数
    customComParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      floderData: [],
      isSubmit: false,
      flowKey: "",
      approve: APPROVE(),
      fileList: [],
      action: "",
      // 默认使用内部的选人组件
      userSelectDlg: "personChoose",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      flowInstanceNodeId: "",
      nodeDef: {},
      allowAddNode: false
    };
  },
  computed: {
    ...mapState({
      routerParams: state => state.projectMg.routerParams
    })
  },

  mounted() {
    console.debug("this.routerParams = ", this.routerParams);
    this.action = uploadDataUrl();
    this.flowKey = this.routerParams.flowKey;
    this.flowStatus = this.routerParams.flowStatus;
    this.flowInstanceNodeId = this.routerParams.flowInstanceNodeId;
    this.nodeDef = {};
    this.checkCanAddNode();
  },

  methods: {
    setNodeId(flowInstanceNodeId) {
      this.flowInstanceNodeId = flowInstanceNodeId;
      this.setFlowInstanceNodeId();
      this.checkCanAddNode();
    },
    setFlowInstanceNodeId() {
      this.approve.flowInstanceNodeId = this.flowInstanceNodeId || this.routerParams.flowInstanceNodeId;
    },
    // 接口:设置审批参数
    setFormData(formJson) {
      this.approve.formJson = formJson;
    },
    setFloderData(list) {
      this.floderData = list;
    },
    // 同意
    async agree() {
      if (this.routerParams.flowKey === "check") {
        this.$emit("getFloderData");
        console.log(this.floderData);
        const list = this.floderData.filter(ele => ele.isRead === 0);
        if (list.length) return this.$warn("有文件未打开查看，请打开查看文件！");
      }
      const success = await this.validateAgree();
      if (!success) {
        return;
      }
      if (this.beforeAgree) {
        const success = await this.beforeAgree();
        console.debug("用户取消了同意操作");
        if (!success) {
          return;
        }
      }
      await this.$confirm("确认同意吗?");
      this.doAgree();
    },

    async doAgree() {
      this.getFormData();
      this.setFlowInstanceNodeId();
      let json = this.approve;
      if (this.queryApproveData) {
        json = this.queryApproveData(ApproveAction.AGREE, this.approve);
      }
      const res = await flowService.agree(json);
      if (res.data && res.data.code && res.data.code === "E.FLOW.0005") {
        this.selectApplicant(res.data || {});
      } else {
        this.$success("操作成功");
        this.$emit("afterAgree");
        this.$emit("reback");
        // this.$router.go(-1);
      }
    },
    // 接口：为特定节点设置处理人
    async selectApplicant(respData) {
      await this.$confirm("要继续，需要对节点：" + respData.nodeName + " 设置处理人，继续吗？");
      const com = getUserSelectDlg();
      if (com) {
        this.userSelectDlg = com;
      }
      this.$nextTick(() => {
        this.$refs.userSelectDlg.show("设置节点 " + respData.nodeName + " 的处理人", { nodeDefinitionId: respData.nodeDefinitionId });
      });
    },

    async validateAgree() {
      if (this.validateFn) {
        const ret = await this.validateFn("agree", this.approve);
        if (ret === 1) {
          return true;
        } else if (ret === 2) {
          return false;
        }
      }
      // 默认的校验，同意不需要更多的校验
      return true;
    },

    getFormData() {
      this.$emit("getFormData");
    },

    // 驳回
    async rejectNodeFlow() {
      const success = await this.validateReject();
      if (!success) {
        return;
      }
      await this.$confirm("此操作将流程驳回至发起人，发起人再次提交后方能继续。确认驳回吗?");
      this.setFlowInstanceNodeId();
      let json = this.approve;
      if (this.queryApproveData) {
        json = this.queryApproveData(ApproveAction.REJECT, this.approve);
      }
      if (!json) {
        json = this.approve;
      }
      await flowService.rejectNodeFlow(json);
      this.$success("驳回成功");
      this.$emit("afterReject");
      this.$emit("reback");
    },
    async validateReject() {
      if (this.validateFn) {
        const ret = await this.validateFn("reject", this.approve);
        if (ret === 1) {
          return true;
        } else if (ret === 2) {
          return false;
        }
      }
      const success = notBlank(this.approve.comment, "驳回意见不能为空");
      return success;
    },

    // 转交
    async transfer() {
      const success = await this.validateTransfer();
      if (!success) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.userSelectDlg.show("选择转交人", { type: 0, transfer: "transfer" });
      });
    },
    async validateTransfer() {
      if (this.validateFn) {
        this.setFlowInstanceNodeId();
        const ret = await this.validateFn("transfer", this.approve);
        if (ret === 1) {
          return true;
        } else if (ret === 2) {
          return false;
        }
      }
      return true;
    },

    async afterUserSelected(users, type, params) {
      if (params && params.nodeDefinitionId) {
        // 指定的节点（一般是下一个节点）
        this.addSpecifiedNodeApproveUser(users, params.nodeDefinitionId);
      } else {
        // 当前节点, 转交操作
        this.setFlowInstanceNodeId();
        this.approve.name = users[0].name;
        this.approve.transferId = users[0].userId;
        await flowService.transfer(this.approve);
        this.$emit("afterTransfer");
        this.$success("转交成功");
        this.$emit("reback");
      }
    },

    // 为特定的节点设置节点审批人
    addSpecifiedNodeApproveUser(userList, nodeDefinitionId) {
      if (!userList || !userList.length) {
        this.$error("没有选择任何人");
        return;
      }
      if (!nodeDefinitionId) {
        this.$error("参数错误，无节点信息");
        return;
      }
      console.debug("为节点：", nodeDefinitionId, "设置审批人：", userList);
      this.approve.nextNodeAssignee = { flowNodeDefinitionId: nodeDefinitionId, userDtoList: userList };
      this.doAgree();
    },

    async checkCanAddNode() {
      if (!this.flowInstanceNodeId) {
        this.allowAddNode = false;
        return;
      }
      const res = await flowService.queryNodeDef(this.flowInstanceNodeId);
      this.nodeDef = res.data || {};
      this.allowAddNode = res.data?.allowAddNode || 0;
    },

    handleTmpNodeChanged() {
      this.$emit("nodesChanged");
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form--label-top .el-form-item__label {
  line-height: 40px;
}

.header-bottom {
  .el-form-item {
    margin-bottom: 10px !important;
  }
}

.midd_yijian {
  .el-form-item {
    margin-bottom: 22px !important;
  }
}

.users {
  background: #fff;
  min-height: 40px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .add {
    font-size: 14px;
    color: #81d3f8;
    line-height: 40px;
  }

  .user_class {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

.buttonGroup {
  height: 40px;
  display: flex;
  justify-content: space-between;

  .fileUpload {
    float: left;
  }

  .approveButton {

    // float: right;
    .el-button {
      margin: 0px 10px;
    }
  }
}

.el-upload-list {
  display: none;
}
</style>
